import {Controller} from "@hotwired/stimulus"

export default class extends Controller {


    toggleField(event) {
        const targetValue = event.target.value;
        const listElement = document.querySelector('[data-id="list"]');
        const referenceElement = document.querySelector('[data-id="reference"]');
        const textElement = document.querySelector('[data-id="text"]');
        listElement.classList.add('hidden');
        referenceElement.classList.add('hidden');
        textElement.classList.add('hidden');


        if (["list", "tab"].includes(targetValue)) {
            listElement.classList.remove("hidden");
        } else if (targetValue === "reference") {
            referenceElement.classList.remove("hidden");
        } else if (["text", "date", "numeric", "month", "month_picker", "year_picker", "fy_picker"].includes(targetValue)) {
            textElement.classList.remove("hidden");
        }
    }

    cloneRow(event) {
        event.preventDefault()
        let dataId = event.target.dataset.id
        const table = document.querySelector(`[data-id="${dataId}"]`)
        let filterColumns = JSON.parse(event.target.dataset.filterColumns)
        let scopeName = event.target.dataset.scopeName
        let subName = event.target.dataset.subName || "filters"
        const rowHtml = this.generateTableRowForColumn(filterColumns, scopeName, dataId, subName, event)
        table.insertAdjacentHTML('beforeend', rowHtml)
    }

    cloneDiv(event) {
        event.preventDefault()
        const parentDiv = document.querySelector("[data-id= other-source]")
        let otherColumns = JSON.parse(event.target.dataset.otherColumns)
        const newDiv = this.generateDiv(otherColumns)
        const form = document.createElement("form")
        form.action = event.target.dataset.url
        form.method = "patch"
        form.dataset.autosubmit_target = "form"
        const wrapperDiv = document.createElement("div")
        wrapperDiv.classList.add("border-dotted", "border-2", "border-gray-400", "p-2", "my-4");
        wrapperDiv.innerHTML = newDiv
        form.appendChild(wrapperDiv)
        parentDiv.appendChild(form)
    }

    generateDiv(columns) {
        let rowHTML = ''
        columns.forEach(col => {
            if (col.type === "array") {
                rowHTML += `
        <div class="flex justify-between my-4">
          <div class="w-1/3">
            <label class="font-medium text-base">${col.label}</label>
          </div>
          <div class="w-2/3">
            <select class="border border-gray-300 rounded focus:outline-none shadow-inner ring-0 text-gray-800 w-full"
                    data-action="change->autosubmit#submit"
                    data-controller="select">
              <option value="">Select ${col.name}</option>
              ${col.select_cols.map(option => `<option value="${option}">${option}</option>`).join('')}
            </select>
          </div>
        </div>
      `
            } else {
                rowHTML += `
        <div class="flex justify-between my-4">
          <div class="w-1/3">
            <label class="font-medium text-base">${col.label}</label>
          </div>
          <div class="w-2/3"><input type="text" name="${col.name}" class="w-full border border-gray-300 rounded focus:outline-none shadow-inner ring-0 text-gray-800" placeholder="Enter ${col.name}"></div>
        </div>
      `

            }
        })
        return rowHTML

    }

    generateTableRowForColumn(columns, scopeName, dataId, subName, event) {
        let rowHTML = '<tr class="border-t">'
        let filter_rand_id = this.randStr()
        columns.forEach(col => {
            if (col.type === "array") {
                let dataAttributes = 'data-controller="select" data-select-create-value="true"';
                if (col.name === "field" && event.target.dataset.optionsUrl) {
                    const url = `${event.target.dataset.optionsUrl}&filter_id=${filter_rand_id}`;
                    dataAttributes += ` data-scope-name="${scopeName}" data-action="change->autosubmit#sendRequest" data-url="${url}"`;
                }
                rowHTML += `<td class="py-2"><div data-controller="autosubmit"><select name="${scopeName}[${subName}][${filter_rand_id}][${col.name}]" class="w-full border border-gray-300 rounded focus:outline-none shadow-inner ring-0 text-gray-800" ${dataAttributes}>
                            <option value="">Select ${col.name}</option>`;
                col.select_cols.forEach(option => {
                    if (Array.isArray(option) && option.length === 2) {
                        let optionText = option[0];
                        let optionValue = option[1];
                        rowHTML += `<option value="${optionValue}">${optionText}</option>`;
                    } else {
                        rowHTML += `<option value="${option}">${option}</option>`;
                    }
                });
                rowHTML += `</select></div></td>`;
            } else if (col.type === "multi_select") {
                rowHTML += `<td class="py-2"><turbo-frame id="frame_value_${filter_rand_id}"><select name="${scopeName}[${subName}][${filter_rand_id}][${col.name}][]" multiple="multiple" class="border border-gray-300 rounded focus:outline-none shadow-inner ring-0 text-gray-800" data-controller="select" data-select-create-value= "true">
                             <option value="">Enter ${col.name}</option>`;
                (col.select_cols || []).forEach(option => {
                    if (Array.isArray(option) && option.length === 2) {
                        let optionText = option[0];
                        let optionValue = option[1];
                        rowHTML += `<option value="${optionValue}">${optionText}</option>`;
                    } else {
                        rowHTML += `<option value="${option}">${option}</option>`;
                    }
                });
                rowHTML += `</select></turbo-frame></td>`;
            } else if (col.type === "boolean") {
                return;
            } else {
                rowHTML += `<td class="py-2"><input type="text" name="${scopeName}[${subName}][${filter_rand_id}][${col.name}]" class="w-full border border-gray-300 rounded focus:outline-none shadow-inner ring-0 text-gray-800 text-xs" placeholder="Enter ${col.name}"></td>`;
            }

        });
        rowHTML += `<td class="w-5 p-2 text-red-600"><i data-lucide="x" class="w-4 h-4 cursor-pointer" data-action="click->builder#deleteRow"></i></td>`
        rowHTML += '</tr>'
        return rowHTML
    }

    deleteRow(event) {
        let tdElement = event.target.closest('td')
        tdElement.parentElement.remove()
    }

    randStr() {
        return (Math.random() + 1).toString(36).substring(7);
    }

    toggleSelectAndTextBox(event) {
        if (event.target.value === "$$Statement") {
            const textElement = document.querySelector('[data-id="function_text_aggregates"]')
            const selectElement = document.querySelector('[data-id="function_select_aggregates"]')
            textElement.classList.remove('hidden')
            selectElement.classList.add("hidden")
            selectElement.querySelector('select').removeAttribute('name')
            textElement.querySelector('input').setAttribute('name', event.target.dataset.fieldName)
        } else {
            const textElement = document.querySelector('[data-id="function_text_aggregates"]')
            const selectElement = document.querySelector('[data-id="function_select_aggregates"]')
            textElement.classList.add('hidden')
            selectElement.classList.remove("hidden")
            textElement.querySelector('input').removeAttribute('name')
            selectElement.querySelector('select').setAttribute('name', event.target.dataset.fieldName);
        }
    }


}
